import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { CLOUD_TEST_FEEDBACKS } from '@elementary/common-ui/constants/queryKeys';
import * as api from 'shared/services/api';
import { CreateFeedbackRequest } from 'shared/types';

const useCreateFeedback = () => {
  const selectedEnvId = useSelectedEnv();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (feedback: CreateFeedbackRequest) =>
      api.createCloudTestFeedbacks(selectedEnvId!, [feedback]),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [CLOUD_TEST_FEEDBACKS] }),
  });
};

export default useCreateFeedback;
